import _ from 'lodash';
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';

window.UIkit = UIkit;
UIkit.use(Icons);
